"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function getCMSDownloadInfo(data, name, noEmitError) {
    var _a;
    const cmsNode = data.nodes.find(n => n.data.Name === name);
    const text = cmsNode === null || cmsNode === void 0 ? void 0 : cmsNode.data.Text;
    const fileInfo = (_a = cmsNode === null || cmsNode === void 0 ? void 0 : cmsNode.data.Download) === null || _a === void 0 ? void 0 : _a.localFiles[0];
    if (fileInfo)
        return {
            text,
            fileName: fileInfo.name,
            prettySize: fileInfo.prettySize,
            publicURL: fileInfo.publicURL,
        };
    if (noEmitError === true)
        return undefined;
    throw new Error(`Text section ${name} not found in ` +
        `the Airtable data specified. Does that ` +
        `query include the right tables, and ` +
        `does one of those tables include a ` +
        `section called ${name}?`);
}
exports.default = getCMSDownloadInfo;
//# sourceMappingURL=getCMSDownloadInfo.js.map